import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: max-content;
  width: max-content;
  display: flex;
  align-items: center;
`;

export const Triangle = styled.div<{
  active: boolean;
  buttonSize?: string;
}>`
  position: absolute;
  z-index: 100;
  right: ${({ buttonSize }) => (buttonSize ? '13px' : '8px')};
  top: calc(100% + 4px);
  height: 16px;
  width: 16px;
  transform: rotate(45deg);
  opacity: ${(props) => (props.active ? '1' : '0')};
  visibility: ${(props) => (props.active ? 'visible' : 'hidden')};
  background-color: #1a055d;
`;

export const Content = styled.div<{
  active: boolean;
  width?: string;
  boxToRight?: boolean;
}>`
  position: absolute;
  top: calc(100% + 8px);
  z-index: 110;
  right: ${({ boxToRight }) => (boxToRight ? '-215px' : '0')};
  background-color: var(--interaction-secondary);
  width: ${({ width }) => width ?? '360px'};
  padding: 8px;
  display: flex;
  border-radius: 4px;
  opacity: ${({ active }) => (active ? '1' : '0')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};

  // @media (max-width: 640px) {
  //   width: 300px;
  // }
`;

export const ContentWrapper = styled.div<{
  buttonSize?: string;
}>`
  width: calc(100% - ${({ buttonSize }) => buttonSize ?? '32px'});
  padding: 8px;
  color: #ffffff;
  font-size: 12px;
  line-height: 16px;

  > h6 {
    font-weight: 900;
    margin-bottom: 8px;
  }

  > p {
  }

  > ul {
    list-style-type: disc;
    padding-left: 20px;

    > li {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const Button = styled.button<{
  iconSize?: string;
  buttonSize?: string;
}>`
  align-items: center;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  outline: none;

  &:hover {
    background-color: #745ef6;
  }

  &:focus-visible,
  &:active {
    background-color: #4318cd;
  }

  &.init {
    &:hover {
      background-color: #e2dffd;
    }

    &:focus-visible,
    &:active {
      background-color: #c6c0fc;
    }
  }
`;
